<button type="submit" class="button is-primary" [ngStyle]="{'opacity' : IsFormDirty() ? 1 : 0.1 }"
  [disabled]="Animate || !IsFormDirty()" (click)="Clicked($event)">
  <span class="icon-text">
    <span class="icon">
      <i class="fa" [ngClass]="Animate ? 'fa-spinner fa-pulse' : GetIcon()"></i>
    </span>
    <span>{{ButtonContext}}</span>

  </span>
</button>